import PropTypes from 'prop-types';
import React, { memo, useEffect, useState } from 'react';
import { Map } from 'immutable';
import classNames from 'classnames';

import { BrowseCheckbox } from '../BrowseCheckbox';

import style from './style.module.css';

const BrowseBuyerActivityFilterComponent = ({ onChange, filter, info }) => {
  const minValue = 0;
  const [maxValue, setMaxValue] = useState(10);
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(0);
  const [type, setType] = useState('number');

  useEffect(() => {
    onChange({
      filterName: filter.get('name'),
      filterData: {
        min,
        max,
        type,
      },
    });
  }, [min, max, type]);

  const handleTypeChange = event => {
    const { checked } = event.target;

    if (checked) {
      setMaxValue(100);
      setMax(100);
      setMin(0);
    } else {
      setMax(0);
      setMin(0);
    }

    setType(checked ? 'percent' : 'number');
  };

  const handleMinChange = event => {
    const { value } = event.target;

    if (value < minValue) {
      setMin(minValue);
    } else if (value > max) {
      setMin(max);
    } else {
      setMin(value ? Number(value) : '');
    }
  };

  const handleMaxChange = event => {
    const { value } = event.target;

    if (value > maxValue && type === 'percent') {
      setMax(maxValue);
    } else if (value < min) {
      setMax(min);
    } else {
      setMax(value ? Number(value) : '');
    }
  };

  return (
    <BrowseCheckbox filter={filter} info={info} onChange={onChange}>
      <div className="d-flex mt10">
        <span>#</span>
        <label className="switch">
          <input className="toggle-checkbox" onChange={handleTypeChange} type="checkbox" />
          <span className="slider round" />
        </label>
        <span>%</span>
      </div>
      <div className={classNames(style.range, 'd-flex')}>
        <input className={style.rangeInput} onChange={handleMinChange} placeholder="Min" type="number" value={min} />
        <div className="form-group">&nbsp;-&nbsp;</div>
        <input className={style.rangeInput} onChange={handleMaxChange} placeholder="Max" type="number" value={max} />
      </div>
    </BrowseCheckbox>
  );
};

BrowseBuyerActivityFilterComponent.propTypes = {
  filter: PropTypes.instanceOf(Map).isRequired,
  info: PropTypes.instanceOf(Map).isRequired,
  onChange: PropTypes.func.isRequired,
};

/** Browse buyer activity filter component. */
export const BrowseBuyerActivityFilter = memo(BrowseBuyerActivityFilterComponent);
